module.exports = __webpack_public_path__ + "img/ic_arrow_slider_inactive_Light.c87f508.svg";